module.exports = __webpack_public_path__ + "static/img/logo-ditu-2.d7e06f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/logo-ditu-2.jpg
// module id = psZk
// module chunks = 2